class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const countContainerMobile = document.getElementById('ProductCountMobile');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
    if (countContainerMobile) {
      countContainerMobile.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderPagination(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderPagination(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderPagination(html) {
    document.getElementById('ProductPagination').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductPagination').innerHTML;

    document
      .getElementById('ProductPagination')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCountHidden');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containerMobile = document.getElementById('ProductCountMobile');
    let customCount = count;
    container.innerHTML = customCount.replace(' products', '');
    containerMobile.innerHTML = customCount.replace(' products', '');
    container.classList.remove('loading');
    containerMobile.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = customCount.replace(' products', '');
      containerDesktop.classList.remove('loading');
    }
    changeVariant();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    // this.setInitialValue();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    // if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    // if (minInput.value) maxInput.setAttribute('min', minInput.value);
    // if (minInput.value === '') maxInput.setAttribute('min', 0);
    // if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    
    minInput.setAttribute('data-value' , minInput.value);
    maxInput.setAttribute('data-value' , maxInput.value);

  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    // const min = Number(input.getAttribute('min'));
    // const max = Number(input.getAttribute('max'));

    // if (value < min) input.value = input.value;
    // if (value > max) input.value = input.value;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function changeVariant(){
  $('.custom-color-variant').find('li:first-child').addClass('active');

  $('.custom-color-variant ul li').click(function(){
    var imageData = $(this).parents('.card-wrapper').find('.card__media').find('img').first();
    var variantImage = $(this).data('img');
    var imageSRCset = imageData.attr('srcset');
    var imageSRC = imageData.attr('src');
    if(!$(this).data('img').includes('gif')){
      $(this).parents('.card-wrapper').find('.custom-color-variant ul li').removeClass('active');
      imageData.attr('srcset', '');
      imageData.attr('src', $(this).data('img'));
      $(this).addClass('active');
    }
  });

}
  
window.onload = function () {
  slideOne();
  slideTwo();
  slideOneMobile();
  slideTwoMobile();
};

let sliderOne = document.getElementById("c-slider-1");
let sliderTwo = document.getElementById("c-slider-2");

let sliderOneMobile = document.getElementById("c-slider-1-m");
let sliderTwoMobile = document.getElementById("c-slider-2-m");

let displayValOne = document.getElementById("c-range1");
let displayValTwo = document.getElementById("c-range2");

let displayValOneMobile = document.getElementById("c-range1-m");
let displayValTwoMobile = document.getElementById("c-range2-m");

let minGap = 0;

let sliderTrack = document.querySelector(".c-slider-track");
let sliderTrackMobile = document.querySelector(".c-slider-track-m");

let sliderMaxValue = document.getElementById("c-slider-1").max;
let sliderMaxValueMobile = document.getElementById("c-slider-1-m").max;


function slideOne() {
  if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
    sliderOne.value = parseInt(sliderTwo.value) - minGap;
  }
  
  let priceFromVal = document.querySelector('.facets__price #Filter-Price-GTE');
  priceFromVal.value = sliderOne.value;
  displayValOne.textContent = sliderOne.value;
  
  fillColor();
}
function slideTwo() {
  if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
    sliderTwo.value = parseInt(sliderOne.value) + minGap;
  }
  let priceFromTo = document.querySelector('.facets__price #Filter-Price-LTE');
  priceFromTo.value = sliderTwo.value;
  displayValTwo.textContent = sliderTwo.value;
  
  fillColor();
}
function fillColor() {
  percent1 = (sliderOne.value / sliderMaxValue) * 100;
  percent2 = (sliderTwo.value / sliderMaxValue) * 100;
  sliderTrack.style.background = `linear-gradient(to right, #dadae5 ${percent1}% , #000 ${percent1}% , #000 ${percent2}%, #dadae5 ${percent2}%)`;
}

//  Mobile filter price slider
function slideOneMobile() {
  if (parseInt(sliderTwoMobile.value) - parseInt(sliderOneMobile.value) <= minGap) {
    sliderOneMobile.value = parseInt(sliderTwoMobile.value) - minGap;
  }
  
  let priceFromVal = document.querySelector('.facets__price #Mobile-Filter-Price-GTE');
  priceFromVal.value = sliderOneMobile.value;
  displayValOneMobile.textContent = sliderOneMobile.value;
  
  fillColorMobile();
}
function slideTwoMobile() {
  if (parseInt(sliderTwoMobile.value) - parseInt(sliderOneMobile.value) <= minGap) {
    sliderTwoMobile.value = parseInt(sliderOneMobile.value) + minGap;
  }
  let priceFromToMobile = document.querySelector('.facets__price #Mobile-Filter-Price-LTE');
  priceFromToMobile.value = sliderTwoMobile.value;
  displayValTwoMobile.textContent = sliderTwoMobile.value;
  
  fillColorMobile();
}
function fillColorMobile() {
  percent1Mobile = (sliderOneMobile.value / sliderMaxValue) * 100;
  percent2Mobile = (sliderTwoMobile.value / sliderMaxValue) * 100;
  sliderTrackMobile.style.background = `linear-gradient(to right, #dadae5 ${percent1Mobile}% , #000 ${percent1Mobile}% , #000 ${percent2Mobile}%, #dadae5 ${percent2Mobile}%)`;
}

$('.c-mobile-facets-wrapper .mobile-facets__summary').click(function(){
  $(this).toggleClass('active');
  $(this).next().slideToggle();
});

const closeFilterDrawer = document.querySelector('.mobile-facets__heading svg');
closeFilterDrawer.addEventListener('click', function(){
  const closeDrawer = document.querySelector(".mobile-facets__close");
  closeDrawer.click();
});